<style lang="scss" scoped>
.tab {
  display: inline-block;
}
.active > span {
  background-color: #e6f1fc;
  border-color: #acd5fd;
  color: #173bcf;
}
</style>

<template>
  <div class="tab">
    <div class="el-radio-group">
      <div
        class="el-radio-button"
        v-for="(item,index) in arr"
        :key="index"
        :class="{'active': type == item.url}"
        @click="router($event)"
      >
        <span class="el-radio-button__inner" :data-url="item.url">{{item.name}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {},
  props: ['arr'],
  watch: {
    '$route.path': function(newVal, oldVal) {
      console.log(newVal);
      this.type = newVal
        .split('/')
        .slice(0, 5)
        .join('/');
    },
  },
  data() {
    return {
      type: this.$route.path
        .split('/')
        .slice(0, 5)
        .join('/'),
    };
  },
  mounted() {},
  methods: {
    router(ev) {
      if (this.$route.path == ev.target.dataset.url) {
        return;
      }
      this.type = ev.target.dataset.url
        .split('/')
        .slice(0, 5)
        .join('/');
      this.$router.push(ev.target.dataset.url);
    },
  },
};
</script>
